import React, {useState, useEffect, useMemo} from "react";
import SelectSearch, { fuzzySearch } from "react-select-search";
import { toast } from "react-toastify";
import { getBarChartDataAPI, getPieChartDataAPI } from "../../common/apiService";
import { numberWithCommas } from "../../service/utilService";
import ConcessionaireDashboardChart, { Legends } from "./ConcessionaireDashboardChart";
import TrendBarChart from "./TrendBarChart";

export default function EntryPointsCharts({jsonData, tollPlazaData}) {
  
const [piChartData, setChartData] = useState({ loader: false, data: [], totalCase:0, totalAmt:0});
const [barChartData, setBarChartData] = useState({loader: false, data: []});
const [distanceBasedPlaza, setDistanceBasedPlaza] = useState("");

useEffect(() => {
  // if(tollPlazaData.length && !distanceBasedPlaza.length 
    if(tollPlazaData.filter((e)=>e.value === distanceBasedPlaza).length==0)
  setDistanceBasedPlaza(tollPlazaData[0].value);
}, [tollPlazaData])

useEffect(() => {
 if(!distanceBasedPlaza) return;
  let headerJson = {
    ...jsonData, 
    plazaIds: distanceBasedPlaza
  }
  getPieChartData(headerJson);
  getBarChartData(headerJson);
}, [jsonData,distanceBasedPlaza])

const getPieChartData = (headerJson)=> {
    setChartData({loader: true, data: [], totalCase:0});
    getPieChartDataAPI(headerJson).then(res=>{
    let json = {
        totalCase: res.data.length > 0 ? res.data.map(e => e.cases).reduce((a, v) => a + v) : 0,
        totalAmt: res.data.length > 0 ? res.data.map(e => e.sumAmount).reduce((a, v) => a + v).toFixed(2) : 0,
        data: res.data,
        loader: false
    }
    setChartData(json);
    }).catch(err=>{
      toast.warn(err?.res?.data?.message)
      setChartData({loader: false,data: [], totalCase:0});
    })
}

const getBarChartData = (headerJson)=> {
      setBarChartData({loader: true, data:[]});
      getBarChartDataAPI(headerJson).then(res=>{
      setBarChartData({loader: false, data: res.data});
    }).catch(err=>{
      toast.warn(err?.res?.data?.message)
      setBarChartData({loader: false, data: []});
    })
}

let legends = useMemo(() => {
  return barChartData.data.reduce((a, v) => {
    const {avc, cases} = v;
    a[avc] = {
         name: avc,
         count: cases+ (a[avc] ? a[avc].count : 0)
     }
     return a;
   },{});
 }, [barChartData]) 

return (
  <div className="entry_point-widget">
    <div className="chart-block-header">
      <div>Summary - Distance Based Plaza</div>
      <div style={{display:'Flex', alignItems:'Center'}}> 
      <p>Exit Plaza:  &nbsp;</p>
      <div  className="entry-point-plaza-lov avc-filter">
        <SelectSearch
          options={tollPlazaData}
          search
          filterOptions={fuzzySearch}
          placeholder="Exit Plaza"
          value={distanceBasedPlaza}
          onChange={setDistanceBasedPlaza}
          name="distanceBasedPlaza"
          disabled={piChartData.loader || barChartData.loader}
        />
      </div>
    </div>
    </div>
      <div className="flex-row line-chart">
        <div className="chart-wrapper" style={{borderRadius:0,padding:'0 30px'}}>
             <ConcessionaireDashboardChart
            chartHeader={"Entry Point - Accepted Transactions Summary"}
            cartHeaderCount={piChartData.totalCase} 
            cartHeaderValue={<>&nbsp;(&#8377;{numberWithCommas(piChartData.totalAmt,2)})</>}
            data={piChartData.data}
            dataKey={"cases"}
            nameKey={"entry_toll_plaza_id"}
            loader={piChartData.loader}
          />
          {!piChartData.loader &&
          <Legends
            dataKey={"cases"}
            nameKey={"entry_toll_plaza_id"}
            data={piChartData.data}
          />}
        </div>
        <div style={{ maxWidth: 5 }}></div>
        <div className="trend-phase5-chart">
          <div className="flex-row">
            <p className="phase5-chart-header">
              Entry Plaza/AVC details for Exit Plaza
            </p>
          </div>
            <TrendBarChart
              loader={barChartData.loader}
              data={barChartData.data}
              entryPoint={true}
            />
            {!barChartData.loader && 
            <Legends
              dataKey={"count"}
              nameKey={"name"}
              data={Object.values(legends)}
              isShort={false}
            /> }
        </div>
      </div>
      <div className="chart-block-footer">
      <div>&nbsp;</div>
    </div>
  </div>
  );
}
